<template>
  <TransitionGroup
    :key="controlButtons.length"
    class="tw:flex tw:h-[30px] tw:justify-center tw:gap-2"
    :name="animate ? 'buttons' : ''"
    tag="div"
  >
    <template v-if="showComponent">
      <BaseButton
        v-for="(button, index) in controlButtons"
        :key="button.key"
        circle
        color="ai"
        :data-testid="`${button.key}`"
        :icon="button.icon"
        new-design
        new-icon
        :style="{ transitionDelay: `${index * 100}ms` }"
        @click="button.onClick"
      >
        <StreemTooltip>
          {{ button.tooltip }}
        </StreemTooltip>
      </BaseButton>
    </template>
  </TransitionGroup>
</template>

<script setup lang="ts">
import { BaseButton, StreemTooltip } from "shared/components/base";
import useAIFeedback, {
  type AIFeedbackEmit,
  type AIFeedbackProps,
} from "shared/composables/useAIFeedback";

const props = defineProps<AIFeedbackProps>();
const emit = defineEmits<AIFeedbackEmit>();

const { controlButtons } = useAIFeedback(props, { emit });
</script>

<style scoped>
.buttons-enter-from {
  opacity: 0;
  transform: translateX(30px);
}

.buttons-enter-to {
  opacity: 1;
  transform: translateX(0);
}

.buttons-enter-active {
  transition: all 0.5s ease-in-out;
}

/* Exit Animation */
.buttons-leave-from {
  opacity: 1;
  transform: translateX(0);
}

.buttons-leave-to {
  opacity: 0;
  transform: translateX(30px);
}

.buttons-leave-active {
  transition: all 0.3s ease-in-out;
}
</style>
